import React from 'react';
import { Chip, Box, Typography } from '@mui/material';

interface StatusChipProps {
  count: number;
  label: string;
  bgcolor: string;
  color: string;
  disabled?: boolean;
}

const StatusChip: React.FC<StatusChipProps> = ({ count, label, bgcolor, color, disabled = false }) => {
  return (
    <Chip
      label={
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          width: '100%'
        }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', lineHeight: 1 }}>
            {count}
          </Typography>
          <Typography variant="caption" sx={{ lineHeight: 1, fontSize: '0.65rem' }}>
            {label}
          </Typography>
        </Box>
      }
      sx={{
        flex: '1 1 0', // Equal flex basis for all chips
        minWidth: '50px', // Reduced minimum width
        maxWidth: 'none', // Remove max width constraint
        height: 'auto',
        padding: '8px 4px',
        backgroundColor: bgcolor,
        color: color,
        border: `1px solid ${color}`,
        opacity: disabled ? 0.6 : 1,
        '& .MuiChip-label': {
          padding: 0,
          width: '100%'
        }
      }}
      variant="outlined"
    />
  );
};

export default StatusChip;